import { StrictMode, useEffect, useState, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import { App } from "./App";
import { LiveDashboard } from "./components/live/LiveDashboard";
import { LiveBook } from "./components/live/LiveBook";
import { LiveAvailability } from "./components/live/LiveAvailability";
import { LiveLessonRoom } from "./components/live/LiveLessonRoom";
import { initAuth, login } from "./lib/auth";

function AuthGate({ children }: { children: ReactNode }): JSX.Element {
  const [state, setState] = useState<"loading" | "redirecting" | "authed">("loading");

  useEffect(() => {
    void (async () => {
      try {
        const r = await initAuth();
        if (r.user) {
          setState("authed");
          return;
        }
        // Remember where we were so callback can come back here.
        sessionStorage.setItem("post_login", window.location.pathname + window.location.search);
        setState("redirecting");
        await login();
      } catch (e) {
        console.error("auth gate init failed", e);
        setState("redirecting");
      }
    })();
  }, []);

  if (state === "authed") return <>{children}</>;
  return (
    <div className="h-full flex items-center justify-center text-ink-400 text-sm">
      {state === "loading" ? "Sprawdzam logowanie…" : "Przekierowanie do Keycloak…"}
    </div>
  );
}

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/live" element={<AuthGate><LiveDashboard /></AuthGate>} />
        <Route path="/live/book" element={<AuthGate><LiveBook /></AuthGate>} />
        <Route path="/live/availability" element={<AuthGate><LiveAvailability /></AuthGate>} />
        <Route path="/live/lesson/:id" element={<AuthGate><LiveLessonRoom /></AuthGate>} />
        {/* Catch-all: existing state-machine App handles "/" and "/auth/callback" */}
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
